// extracted by mini-css-extract-plugin
export default {"root":"SelectFromCloudPopup__root--7EUT-","modal":"SelectFromCloudPopup__modal--1XQ34","title":"SelectFromCloudPopup__title--1w3mg"};